import axios from "axios";
import { API } from "./api";

// Локальная сессия студии: если человек случайно закрыл Mini App, при повторном
// открытии (в течение TTL) предлагаем продолжить с того же места (вопрос на входе).
const KEY = "afanasiev_session_v1";
const PHOTO_KEY = "afanasiev_session_photo"; // фото отдельным ключом: при перетаскивании маски не переписываем ~0.5МБ каждые 400мс
const TTL_MS = 5 * 60 * 1000;

export const loadSession = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const s = JSON.parse(raw);
    if (!s.ts || Date.now() - s.ts > TTL_MS) {
      localStorage.removeItem(KEY);
      localStorage.removeItem(PHOTO_KEY);
      return null;
    }
    s.photo = localStorage.getItem(PHOTO_KEY) || undefined;
    return s;
  } catch {
    return null;
  }
};

let pendingPatch = {};
let timer = null;

// Снапшот сессии на момент открытия приложения: лендинг читает его для
// автоперехода, пока RouteMemory не перезаписал текущий маршрут
let entrySnapshot;
export const getEntrySnapshot = () => {
  if (entrySnapshot === undefined) entrySnapshot = loadSession();
  return entrySnapshot;
};

const writeNow = () => {
  const patch = pendingPatch;
  pendingPatch = {};
  if (!Object.keys(patch).length) return;
  try {
    if (patch.photo !== undefined) {
      try {
        localStorage.setItem(PHOTO_KEY, patch.photo);
      } catch {
        // не влезло в квоту — сессия восстановится без фото (откроется экран загрузки)
      }
      delete patch.photo;
    }
    if (!Object.keys(patch).length) return;
    const cur = loadSession() || {};
    localStorage.setItem(KEY, JSON.stringify({ ...cur, ...patch, ts: Date.now() }));
  } catch {
    // Переполнение localStorage — сессия просто не сохранится, работе приложения не мешает
  }
};

// Сохранения частые (маску таскают непрерывно) — сливаем их с паузой 400мс
export const saveSession = (patch) => {
  pendingPatch = { ...pendingPatch, ...patch };
  if (timer) return;
  timer = setTimeout(() => {
    timer = null;
    writeNow();
  }, 400);
};

// Критичные точки (новое фото, готовый разбор) — пишем немедленно
export const flushSession = () => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  writeNow();
};

export const clearSession = () => {
  pendingPatch = {};
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  try {
    localStorage.removeItem(KEY);
    localStorage.removeItem(PHOTO_KEY);
  } catch {}
};

export const addPendingJob = (job) => {
  const cur = loadSession() || {};
  saveSession({ pendingJobs: [...(cur.pendingJobs || []).filter((j) => j.id !== job.id), job] });
  flushSession();
};

export const removePendingJob = (id) => {
  const cur = loadSession() || {};
  saveSession({ pendingJobs: (cur.pendingJobs || []).filter((j) => j.id !== id) });
  flushSession();
};

// Карточка примерки с сервера → data URL, чтобы логика канваса и скачивания не менялась
export const fetchImageDataUrl = async (iid) => {
  const { data } = await axios.get(`${API}/images/${iid}`, { responseType: "blob", timeout: 30000 });
  return await new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => resolve(fr.result);
    fr.onerror = reject;
    fr.readAsDataURL(data);
  });
};
